var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("delegation-rate-menu"),
      _c(
        "v-row",
        { staticClass: "mb-3" },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "group-delegation-form-dialog",
                { attrs: { id: null }, on: { saved: _vm.loadList } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.delegationRate.groupDelegationRate.addNewGroup"
                        )
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.groupList,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.description))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.count_rates))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.parent_group_name.length == 0
                            ? _vm.$t(
                                "settings.delegationRate.customDelegationRate.systemSettings"
                              )
                            : props.item.parent_group_name
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(props.item.count_users) + " "),
                    props.item.child_group_names !== null
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "settings.delegationRate.groupDelegationRate.usersAndChildGroups"
                                )
                              ) +
                              ": " +
                              _vm._s(props.item.child_group_names)
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center text-no-wrap" },
                    [
                      _c("group-delegation-form-dialog", {
                        attrs: { id: props.item.id },
                        on: { saved: _vm.loadList }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled: !_vm.canBeDeleted(
                                              props.item
                                            ),
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.remove(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          !_vm.canBeDeleted(props.item)
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "settings.delegationRate.groupDelegationRate.detachChildFirst"
                                    )
                                  )
                                )
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("global.delete")))
                              ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c("v-alert", { attrs: { type: "info" } }, [
        _vm._v(
          _vm._s(
            _vm.$t("settings.delegationRate.groupDelegationRate.addUserInfo")
          )
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }